export interface DepartmentApi {
  departmentId: string;
  name: string;
}

/** Matches the AppRole enum in the backend (ResourceNexus.Domain.Auth). */
export const AppRole = {
  OrganizationAdministrator: 'OrganizationAdministrator',
  OrganizationResourceManager: 'OrganizationResourceManager',
  DepartmentResourceManager: 'DepartmentResourceManager',
  DepartmentMember: 'DepartmentMember',
} as const;

export type AppRoleValue = typeof AppRole[keyof typeof AppRole];

export interface MeRoleApi {
  roles: AppRoleValue[];
  assignedDepartments: DepartmentApi[];
  /** Departments in the caller's WriteScope (DepartmentResourceManager assignments). */
  writableDepartments: DepartmentApi[];
}
